import { useCallback, useEffect } from "react"
import { isEmpty } from "lodash"

const lastThreeCharactersRegex = /...$/gi
export default function useDownloadData({ configKey, name, setDownloadData, generateHeaders, generateRows, sectionIndex }) {
  const generateXlsxData = useCallback(() => {
    const rows = generateRows()
    if (isEmpty(rows)) { return null }

    return {
      id: configKey,
      // There is a limit of 31 characters for the name of sheet, so we truncate the name if it's too long
      // to avoid a failing download. Button would appear broken.
      name: name.length > 31 ? name.slice(0, 31).replace(lastThreeCharactersRegex, "...") : name,
      rows: [
        generateHeaders(),
        ...rows,
      ],
    }
  }, [configKey, name, generateHeaders, generateRows])

  useEffect(() => {
    setDownloadData(generateXlsxData, configKey, sectionIndex)
    return () => {
      setDownloadData(null, configKey)
    }
  }, [configKey, setDownloadData, generateXlsxData, sectionIndex])
}
